import {NgForm} from '@angular/forms';

export function validate(form: NgForm) {
    for (const controlKey of Object.keys(form.controls)) {
        const control = form.controls[controlKey];
        control.markAsTouched();
    }
}
